import type {FC, ReactNode} from 'react';
import {cn} from '../../../../../lib/classname';

type Props = {
  /** クリック時のハンドラ */
  onClick: () => void;
  /** ボタンの無効化状態 */
  disabled?: boolean;
  /** ボタンのラベルテキスト */
  children: ReactNode;
  /** 追加のCSSクラス */
  className?: string;
};

/**
 * モーダル用のキャンセルボタンコンポーネント
 *
 * @description
 * モーダル内で使用する標準的なキャンセルボタン。
 * 白背景にプライマリカラーのボーダーとテキストを持つ。
 */
export const ModalCancelButton: FC<Props> = ({
  onClick,
  disabled = false,
  children,
  className,
}) => {
  return (
    <button
      type="button"
      className={cn(
        'min-w-[128px] text-base font-bold rounded-full px-16 py-[10px] border-[2px] hover:opacity-80',
        {
          'border-background-2 bg-background-2 text-black-3 cursor-not-allowed':
            disabled,
          'border-primary bg-white text-primary': !disabled,
        },
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
